<aside class="wrapper-user-form">
  <div class="col-md-12">
    <div class="row ">
      <div class="col-12 py-2 px-1">
        <div *ngIf="!paramsDialog?.driver" (click)="backView()" class="back-view">
          <i class="fas fa-arrow-left"></i>
          Volver al listado
        </div>
      </div>
      <div class="col-md-12 wrapper-detail" *ngIf="userDocument">
        <i *ngIf="paramsDialog && paramsDialog.driver" matTooltip="Cerrar"
          class="fas fa-times fa-2xl close-icon-actions" (click)="dialogRef.close()"></i>
        <div class="title-component px-5 px-sm-0">
          <div class="col-md-12 p-0">
            <div class="row">
              <div class="state-container">
                <i class="fas fa-user-edit"></i>
                {{this.mode === 'created' ? 'Crear' : 'Ver'}} usuario
                <span *ngIf="userStateByValidationRules?.description" class="badge badge-warning"
                  [ngClass]="getBadgeClass(userStateByValidationRules?.description)">
                  Estado: {{userStateByValidationRules?.description }}
                </span>
              </div>
            </div>
          </div>
        </div>
        <app-rndc-contingency-alert [entity]="userRndcFlags" entityType="user"></app-rndc-contingency-alert>
        <mat-divider></mat-divider>
        <br>
        <mat-tab-group>
          <mat-tab label="Información general">
            <app-person-vehicle *ngIf="form" [userDocument]="userDocument" [title]="roleTranslated()"
              [typeAction]="'editDriver'" [form]="form" [paramsDialog]="paramsDialog" [user]="user"
              [extraInformationUserOptions]="{isTeclogiUserOrClient: isTeclogiUserOrClient }"
              [documentValidation]="documentValidation" (emitUploadDocument)="dialogRef.close({ state: true })"
              (emitRefreshLoad)="getDetailUserByDocument($event)" (emitLoadUpdated)="loadUpdated()"
              (emitUser)="userRndcFlags = $event" (emitTypedDocRules)="typedDocRules = $event">
            </app-person-vehicle>
            <!-- Razones para desactivar -->
            <ng-container
              *ngIf="form?.get('state')?.value && !userStateByValidationRules?.active && userStateByValidationRules?.description !== 'Estudio de seguridad en proceso' && userStateByValidationRules?.description !== 'Pending'">
              <ng-container *ngTemplateOutlet="cannotActivateReasons"></ng-container>
            </ng-container>
            <!-- Actions -->
            <ng-container *ngTemplateOutlet="actions"></ng-container>
          </mat-tab>
          <mat-tab label="Documentos">
            <app-user-documents *ngIf="form && form.get('information.document').value" [form]="form" [hideBtn]="false"
              [role]="role" [previewPrevizualizationSettings]="previsualizationSettings"
              (emitPreviewsResources)="setPreviewsResources($event)">
            </app-user-documents>
          </mat-tab>
          <mat-tab label="Aceptaciones legales">
            <div class="legal-acceptances">
              <div class="legal-acceptances-grid" *ngIf="hasLegalAcceptances; else noLegalAcceptances">
                <mat-card class="legal-acceptance-card" *ngFor="let doc of visibleLegalAcceptances"
                  [class.legal-acceptance-card--logistics]="doc.logistics">
                  <div class="legal-acceptance-card__header">
                    <div class="legal-acceptance-card__icon">
                      <i class="fas" [ngClass]="doc.icon"></i>
                    </div>
                    <div class="legal-acceptance-card__title">
                      <h5>{{ doc.label }}</h5>
                      <span class="legal-acceptance-card__chip" *ngIf="doc.logistics">Logistics</span>
                    </div>
                    <span class="legal-acceptance-card__status">
                      <i class="fas fa-check-circle"></i> Aceptado
                    </span>
                  </div>
                  <div class="legal-acceptance-card__body">
                    <div class="legal-acceptance-card__row">
                      <i class="far fa-calendar-alt"></i>
                      <span>{{ formatDate(form?.get(doc.formKey)?.value?.fingerprint?.date) }}</span>
                    </div>
                    <div class="legal-acceptance-card__row">
                      <i class="far fa-clock"></i>
                      <span>{{ dm.onlyTime(form?.get(doc.formKey)?.value?.fingerprint?.date) }}</span>
                    </div>
                    <div class="legal-acceptance-card__row">
                      <i class="fas fa-code-branch"></i>
                      <span>Versión {{ form?.get(doc.formKey)?.value?.version ? form?.get(doc.formKey)?.value?.version : 'sin especificar' }}</span>
                    </div>
                  </div>
                  <a *ngIf="legalDocumentsUrls[doc.formKey]" [href]="legalDocumentsUrls[doc.formKey]" target="_blank"
                    rel="noopener" mat-stroked-button class="legal-acceptance-card__link">
                    <i class="fas fa-file-pdf"></i> Ver documento
                  </a>
                </mat-card>
              </div>
              <ng-template #noLegalAcceptances>
                <div class="legal-acceptances-empty">
                  <i class="fas fa-folder-open"></i>
                  <p>No hay aceptaciones legales registradas.</p>
                </div>
              </ng-template>
            </div>
          </mat-tab>
        </mat-tab-group>
      </div>



      <!-- Cannot activate reason template -->
      <ng-template #cannotActivateReasons>
        <div class="cannot-activate-reasons" *ngIf="cannotActivateReason?.length > 0">
          <div class="cannot-activate-reasons__header">
            <i class="fas fa-exclamation-triangle"></i>
            <span>Motivos de inactivación</span>
          </div>
          <ul class="cannot-activate-reasons__list">
            <li *ngFor="let reason of cannotActivateReason">
              <i class="fas fa-ban"></i>
              <span>{{ reason }}</span>
            </li>
          </ul>
        </div>
      </ng-template>


      <ng-template #actions>
        <div class="d-flex flex-wrap align-items-center justify-content-center mt-3" *ngIf="showUserOptions">
          <button mat-raised-button type="button" [matMenuTriggerFor]="menuUserOptions"
            class="primary-secondary button-width-auto mb-3 button-small" color="primary">
            Opciones
          </button>
        </div>
      </ng-template>
    </div>
  </div>

</aside>
<mat-menu #menuUserOptions="matMenu">
  <button mat-menu-item [matMenuTriggerFor]="menuOptionsDocuments" *ngIf="showButtonValidateDocuments">
    <i class="fas fa-file-alt mr-2"></i>
    Validar documentos
  </button>
  <button mat-menu-item *ngIf="showButtonSecurityAnalysis" (click)="getUrlPDFTruora()">
    <i class="fas fa-shield-alt mr-2"></i>
    Ver análisis de seguridad
  </button>
  <button mat-menu-item *ngIf="showButtonFinalizeStudy" (click)="finalizeStudyTruora()">
    <i class="fas fa-clipboard-check mr-2"></i>
    Finalizar estudio
  </button>
  <button mat-menu-item *ngIf="canDisableEnableUsers && showButtonActivateUser" (click)="confirmActive()">
    <i class="fas fa-user-check mr-2"></i>
    Activar usuario
  </button>
  <button mat-menu-item *ngIf="canDisableEnableUsers && showButtonDeactivateUser" (click)="openDialogDeactivateUser()">
    <i class="fas fa-user-slash mr-2"></i>
    Desactivar usuario
  </button>
  <button mat-menu-item *ngIf="showButtonForceActivation" (click)="confirmForceActivation()">
    <i class="fas fa-star mr-2"></i>
    Activar por Score
  </button>
  <button mat-menu-item *ngIf="showButtonReverseScoreActivation" (click)="openDialogReverseScoreActivation()">
    <i class="fas fa-undo mr-2"></i>
    Reversar activación por score
  </button>
  <button mat-menu-item *ngIf="showButtonActivateByRestrictedCompanies"
    (click)="confirmActivateByRestrictedCompanies()">
    <i class="fas fa-building mr-2"></i>
    Activar por empresas restringidas
  </button>
  <button mat-menu-item *ngIf="showButtonReverseRestrictedCompanies" (click)="openDialogReverseRestrictedCompanies()">
    <i class="fas fa-ban mr-2"></i>
    Revertir activación por empresas restringidas
  </button>
</mat-menu>
<mat-menu #menuOptionsDocuments="matMenu">
  <button mat-menu-item (click)="getURLDocument('ARL')"
    *ngIf="form && adminUsersService.getExtraDocumentByType('ARL', form.getRawValue()) && getPendingApprovalByType('ARL', form.getRawValue())">
    ARL
  </button>
  <button mat-menu-item (click)="getURLDocument('EPS')"
    *ngIf="form && adminUsersService.getExtraDocumentByType('EPS', form.getRawValue()) && getPendingApprovalByType('EPS', form.getRawValue())">
    EPS
  </button>
  <button mat-menu-item (click)="getURLDocument(additionalCertificationEnum.OPERATIONAL_ACCREDITATION)"
    *ngIf="form && adminUsersService.getAdditionalCertificationByType(additionalCertificationEnum.OPERATIONAL_ACCREDITATION, additionalCertifications) && getPendingApprovalAdditionalCertification(additionalCertificationEnum.OPERATIONAL_ACCREDITATION)">
    Acreditación de personal operativo
  </button>
</mat-menu>

<!-- Modal Force Activation User-->
<ng-template #modalConfirmForceActivation let-modal>
  <div class="modal-body wrapper-modal">
    <p class="title" *ngIf="user.getInformation().getDocument()">
      ¿Estás seguro que deseas <br> forzar la activacíon de <br> {{user.getInformation().getName()}}?
    </p>
    <mat-card-actions>
      <button mat-raised-button class="primary-secondary" color="primary" (click)="hideModals()">No</button>
      <button mat-raised-button color="primary" (click)="forzeActivation()">Si</button>
    </mat-card-actions>
  </div>
</ng-template>

<!-- Modal PDF TRUORA -->
<ng-template #modalPDFTruora let-modal>
  <div class="modal-body wrapper-modal modal-content-PDF" *ngIf="urlPDFTruora">
    <embed [src]="urlPDFTruora" type="application/pdf">
  </div>
</ng-template>